module.exports = __webpack_public_path__ + "img/t6.5fc73b00.jpg";